import { Button } from "primereact/button";
import { Card } from "primereact/card";

const CheckoutStatusCard = ({
  variant = "default",
  chipClassName = "",
  chipText,
  title,
  description,
  iconClassName,
  metaRows = [],
  primaryAction,
  secondaryAction,
}) => (
  <div className="getnet-status-shell">
    <Card className="getnet-status-card">
      <div className={`getnet-status-icon ${variant}`.trim()}>
        <i className={iconClassName}></i>
      </div>
      <span className={`getnet-chip ${chipClassName}`.trim()}>{chipText}</span>
      <h2>{title}</h2>
      <p>{description}</p>

      {metaRows.length ? (
        <div className="getnet-status-meta">
          {metaRows.map((item) => (
            <div key={item.label}>
              <span>{item.label}</span>
              <strong>{item.value}</strong>
            </div>
          ))}
        </div>
      ) : null}

      {primaryAction || secondaryAction ? (
        <div className="getnet-actions centered">
          {primaryAction ? (
            <Button
              label={primaryAction.label}
              rounded
              className="getnet-primary-btn"
              onClick={primaryAction.onClick}
            />
          ) : null}
          {secondaryAction ? (
            <Button
              label={secondaryAction.label}
              outlined
              rounded
              className="getnet-secondary-btn"
              onClick={secondaryAction.onClick}
            />
          ) : null}
        </div>
      ) : null}
    </Card>
  </div>
);

export default CheckoutStatusCard;
